// =============================================================================
// App
// =============================================================================

// Import
// =============================================================================

import './library/HeaderPop';
import './library/Carousel';
import './library/FindYour';
import './library/Lightbox';
import './library/Gallery';
import './library/MegaNav';
import './library/FamilyFilter';
import './library/ClubFilter';
import './library/Protection';
import './library/Analytics';
import './library/ContactForms';

// Constants
// =============================================================================

const $window = $(window);

// Document Ready
// =============================================================================

$('document').ready(() => {
    // TODO: Add handler for "Find Your Club" menu
    // $('[href="#find-your-club"]').on('click', () => alert('Open "Find Your Club" menu'));
});

// Window Ready
// =============================================================================

$window.on('load', () => {
    // ...
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/app.js